import React, { useState, useEffect, Fragment } from 'react'
import { func } from 'prop-types'
import i18next from 'i18next'
import classNames from 'classnames'
import { Cookie } from '@mercadona/mo.library.web-services/cookies'

import { BigModal } from '@mercadona/mo.library.shop-ui/modal'
import { CookieInformation } from 'app/cookie/components/cookie-information'
import { Checkbox } from 'system-ui/checkbox'
import { COOKIES, THIRD_PARTY_COOKIES } from 'app/cookie/constants'

import './CookieConfiguration.css'

const { REACT_APP_ACCEPTED_COOKIES } = process.env

const CookieConfiguration = ({ closeConfiguration, acceptCookies }) => {
  const [isNecessaryInfoOpen, setNecessaryInfoOpen] = useState(false)
  const [isThirdpartyInfoOpen, setThirdpartyInfoOpen] = useState(false)
  const [isThirdpartyCookieAccepted, setThirdpartyCookieAccepted] =
    useState(false)

  useEffect(() => {
    const cookie = Cookie.get(REACT_APP_ACCEPTED_COOKIES)

    if (!cookie || !cookie.thirdParty) return

    setThirdpartyCookieAccepted(true)
  }, [])

  const necessaryInfoIcon = classNames(
    'icon cookie-banner-configuration__list-icon',
    !isNecessaryInfoOpen ? ' ic-chevron-right-16' : 'ic-16-chevron-down',
  )
  const thirdparyInfoIcon = classNames(
    'icon cookie-banner-configuration__list-icon',
    !isThirdpartyInfoOpen ? ' ic-chevron-right-16' : 'ic-16-chevron-down',
  )

  const removeQueryParam = () => {
    window.history.replaceState(null, '', '/')
  }

  const handleThirdPartyCookies = () => {
    if (isThirdpartyCookieAccepted) {
      acceptCookies(true)
    }
    if (!isThirdpartyCookieAccepted) {
      acceptCookies(false)
    }

    closeCookieConfiguration()
  }

  const closeCookieConfiguration = () => {
    removeQueryParam()
    closeConfiguration()
  }

  return (
    <BigModal
      title={i18next.t('cookies_configuration_title')}
      description={[
        i18next.t('cookies_configuration_body_necessary'),
        i18next.t('cookies_configuration_body_thirdparty'),
      ]}
      primaryAction={handleThirdPartyCookies}
      secondaryAction={closeCookieConfiguration}
      primaryActionText={i18next.t('cookies_configuration_accept')}
      secondaryActionText={i18next.t('cookies_configuration_cancel')}
      hideModal={closeCookieConfiguration}
    >
      <ul className="cookie-banner-configuration__list">
        <li className="cookie-banner-configuration__list-title">
          <div className="cookie-banner-configuration__list-title-box">
            <button
              className="cookie-banner-configuration__list-title-text"
              onClick={() => setNecessaryInfoOpen(!isNecessaryInfoOpen)}
            >
              <i className={necessaryInfoIcon} />
              {i18next.t('cookies_configuration_necessary_title')}
            </button>
            <span className="cookie-banner-configuration__list-status">
              {i18next.t('cookies_configuration_always_active')}
            </span>
          </div>
          {isNecessaryInfoOpen && (
            <Fragment>
              <p className="cookie-banner-configuration__explanation">
                {i18next.t('cookies_configuration_necessary_explanation')}
              </p>
              <CookieInformation
                name="__mo_da"
                expiration="__mo_da_expiration"
                description="__mo_da_description"
              />
              <CookieInformation
                name="__mo_ca"
                expiration="__mo_ca_expiration"
                description="__mo_ca_description"
              />
              <CookieInformation
                name="__mo_ui"
                expiration="__mo_ui_expiration"
                description="__mo_ui_description"
              />
              <CookieInformation
                name={COOKIES.ZLCMID}
                expiration={`${COOKIES.ZLCMID}_expiration`}
                description={`${COOKIES.ZLCMID}_description`}
              />
              <CookieInformation
                name={COOKIES.AMPLITUDE_ID}
                expiration={`${COOKIES.AMPLITUDE_ID}_expiration`}
                description={`${COOKIES.AMPLITUDE_ID}_description`}
              />
            </Fragment>
          )}
        </li>
        <li className="cookie-banner-configuration__list-title">
          <div className="cookie-banner-configuration__list-title-box">
            <button
              className="cookie-banner-configuration__list-title-text"
              onClick={() => setThirdpartyInfoOpen(!isThirdpartyInfoOpen)}
            >
              <i className={thirdparyInfoIcon} />
              {i18next.t('cookies_configuration_thirdparty_title')}
            </button>
            <Checkbox
              checked={isThirdpartyCookieAccepted}
              ariaLabel={i18next.t(
                'cookies_configuration_accept_thirdparty_cookies',
              )}
              onChange={() =>
                setThirdpartyCookieAccepted(!isThirdpartyCookieAccepted)
              }
            />
          </div>
          {isThirdpartyInfoOpen && (
            <Fragment>
              <p className="cookie-banner-configuration__explanation">
                {i18next.t('cookies_configuration_thirdparty_explanation')}
              </p>
              {THIRD_PARTY_COOKIES.map((cookie) => (
                <CookieInformation
                  key={cookie}
                  name={cookie}
                  expiration={`${cookie}_expiration`}
                  description={`${cookie}_description`}
                />
              ))}
            </Fragment>
          )}
        </li>
      </ul>
    </BigModal>
  )
}

CookieConfiguration.propTypes = {
  closeConfiguration: func.isRequired,
  acceptCookies: func.isRequired,
}

export { CookieConfiguration }
